export const filteredFilters = (flightList, filterTimes) => {
  let resultFilter = {
    Airline: [],
    Stops: 0,
    Origin: "",
    Destination: "",
    MaxPrice: 0,
    MinPrice: 0,
    Currency: "",
    FilterTimes: filterTimes,
  };
  flightList.forEach((airlineItem, i) => {
    airlineItem.OriginDest.forEach((origindest) => {
      resultFilter.Origin = origindest.Origin;
      resultFilter.Destination = origindest.Destination;
      origindest.FlightDetails.forEach((flightdetail, i) => {
        if (i > 0 && i >= resultFilter.Stops) {
          resultFilter.Stops++;
        }
        if (flightdetail.Code === airlineItem.ValidatingCarrier) {
          let hasExisting =
            resultFilter.Airline.length > 0
              ? resultFilter.Airline.find(
                (filter) => filter.FlightCode == flightdetail.Code
              )
              : false;
          if (!hasExisting) {
            resultFilter.Airline.push({
              FlightCode: flightdetail.Code,
              FlightName: flightdetail.Name,
            });
          }
        }
      });
    });


    var maxPr = airlineItem.FareOptions[airlineItem.FareOptions.length - 1];
    if (resultFilter.MaxPrice < maxPr.GTotalFare)
      resultFilter.MaxPrice = maxPr.GTotalFare;
    var minPr = airlineItem.FareOptions[0];
    if (resultFilter.MinPrice > minPr.GTotalFare || i === 0)
      resultFilter.MinPrice = minPr.GTotalFare;
    resultFilter.Currency = minPr.Currency;
  });
  // for (let index = 1; index <= totalAirlines; index++) {
  //   resultFilter.Stops.push({ Name: `${index} Stops`, value: index });
  // }
  return resultFilter;
};
